import { useNotificationsContext } from "common/context/NotificationsProvider"
import { Button } from "primereact/button"
import { useTranslation } from "react-i18next"

import "../style.scss"

const NotificationsMenuListHeader = () => {
  const { t } = useTranslation()
  // @ts-expect-error TS(2339): Property 'markAllNotificationsAsRead' does not exi...
  const { markAllNotificationsAsRead, unReadNotifications } =
    useNotificationsContext()

  return (
    <div className='flex-row notifications-menu-list-header w-100 d-flex justify-content-between'>
      <div className='notifications-menu-no-read'>{`${t(
        "notificationsMenu.header.noReading"
      )} (${unReadNotifications.totalCount})`}</div>
      {unReadNotifications.totalCount > 0 && (
        <Button
          className='p-button-text notifications-menu-actions'
          onClick={markAllNotificationsAsRead}
        >
          {t("notificationsMenu.header.markRead")}
        </Button>
      )}
    </div>
  )
}

export default NotificationsMenuListHeader
